import React, { useState } from 'react';
import { Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

function PdfButtonDropdown({ saveAndOpenPdf, color, prefix="Save and View " }) {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen(!dropdownOpen);

    return (
        <ButtonDropdown isOpen={dropdownOpen} toggle={toggle} className="mx-2">
            <Button color={color} className="button-styles" onClick={() => saveAndOpenPdf("quote")}>
                {prefix}PDF
            </Button>
            <DropdownToggle color={color}  caret className="button-styles" />
            <DropdownMenu>
                <DropdownItem onClick={() => saveAndOpenPdf("invoice")}>{prefix}Invoice</DropdownItem>
                <DropdownItem onClick={() => saveAndOpenPdf("paid-invoice")}>{prefix}Paid Invoice</DropdownItem>
            </DropdownMenu>
        </ButtonDropdown>
    );
}

export default PdfButtonDropdown;
